// @flow @jsx h
import { h, Component } from 'preact'
import { matches } from '../../../lib/matches'

type Props = {
  children: any,
  path: string,
  multiple?: boolean
}

class Router extends Component<Props, {}> {
  getCurrentChildren = (): any[] => {
    const { children, path } = this.props
    const matchingChildren = children.filter(child => {
      const { attributes } = child
      if (attributes && attributes.path) {
        if (Array.isArray(attributes.path)) {
          return matches(path, ...attributes.path)
        }
        return matches(path, attributes.path)
      }
      return false
    })

    if (matchingChildren.length) {
      return matchingChildren
    }

    const defaultChildren = children.filter(
      child => child.attributes && child.attributes.default
    )

    return defaultChildren
  }
  render() {
    const { multiple } = this.props
    const currentChildren = this.getCurrentChildren()
    if (multiple) {
      return <div>{currentChildren}</div>
    }
    return currentChildren[0] || null
  }
}

export { Router }



// WEBPACK FOOTER //
// ./src/v1/components/lib/Router.js